import React, { useCallback } from 'react';
import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from '@atlassian/jira-intl';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { ProjectCreateDrawerConsumer } from '@atlassian/jira-project-create-drawer-context/src/index.tsx';
import emptyImageUrl from './assets/empty.svg';
import messages from './messages.tsx';

type OpenDrawerMethod = (
	attributes:
		| {
				isNextGen?: boolean;
				showExperienceSelection?: boolean;
		  }
		| undefined,
) => void;

export const NoProjects = () => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsEvent = createAnalyticsEvent({
		action: 'clicked',
		actionSubject: 'emptyView',
	});

	const handleCreate = useCallback(
		(open: OpenDrawerMethod) => {
			open({ isNextGen: false, showExperienceSelection: false });
			fireUIAnalytics(analyticsEvent, 'CreateProjectButton');
		},
		[analyticsEvent],
	);

	return (
		<ProjectCreateDrawerConsumer>
			{({ methods: { open } }) => (
				<EmptyState
					width="narrow"
					imageUrl={emptyImageUrl}
					header={formatMessage(messages.header)}
					description={formatMessage(messages.description)}
					primaryAction={
						<Button appearance="primary" onClick={() => handleCreate(open)}>
							{formatMessage(messages.createProject)}
						</Button>
					}
				/>
			)}
		</ProjectCreateDrawerConsumer>
	);
};
